<template>
  <div style="font-size: 20px;width: 100%;height: 100%;">
    <el-empty style="width: 100%;height: 100%;" :image-size="200" description="页面未找到，或者没有权限查看，请检查url或者联系管理员！"></el-empty>
  </div>
</template>

<script>
export default {
  name: 'PageNotFound',
}
</script>

<style></style>
